<template>
    <Loading v-bind:show="showLoading">
        <div v-if="!showLoading">
            <PageTitle title="Histórico Escolar" />
            <div class="md-layout-item md-size-100" v-if="dadosAba">
                <div class="divHistoricoEscolar" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_CHDICIPLINACURSO">
                    <p class="s-h2">CH - Disciplinas Curso</p>

                    <Info v-bind:Informacao="dadosAba.historicoEscolar.cargaHoraria.cargaHorariaCursadaDisciplina.toString()"
                          Descricao="CURSADA"
                          BordaCor="009688"
                          Tipo="texto" />

                    <Info v-bind:Informacao="dadosAba.historicoEscolar.cargaHoraria.cargaHorariaDisciplina.toString()"
                          Descricao="CONTRATADA"
                          BordaCor="6361fb"
                          Tipo="texto" />
                </div>

                <div class="divHistoricoEscolar div330" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_CHATIVIDADESCOMPLEMENTARES">
                    <p class="s-h2">CH - Atividades Complementares</p>

                    <Info Titulo=""
                          v-bind:Informacao="dadosAba.historicoEscolar.cargaHoraria.cargaHorariaCursadaComplementar.toString()"
                          Descricao="CURSADA"
                          BordaCor="009688"
                          Tipo="texto" />

                    <Info Titulo=""
                          v-bind:Informacao="dadosAba.historicoEscolar.cargaHoraria.cargaHorariaComplementar.toString()"
                          Descricao="CONTRATADA"
                          BordaCor="6361fb"
                          Tipo="texto" />
                </div>

                <div class="divHistoricoEscolar" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_CHTOTAL">
                    <p class="s-h2">CH - Total</p>

                    <Info Titulo="CH - Total"
                          v-bind:Informacao="dadosAba.historicoEscolar.cargaHoraria.cargaHorariaCursadaTotal.toString()"
                          Descricao="CURSADA"
                          BordaCor="009688"
                          Tipo="texto" />

                    <Info Titulo=""
                          v-bind:Informacao="dadosAba.historicoEscolar.cargaHoraria.cargaHorariaCurso.toString()"
                          Descricao="CONTRATADA"
                          BordaCor="6361fb"
                          Tipo="texto" />
                </div>
                <div style="clear:both"></div>
                <div class="divHistoricoEscolar">

                    <p class="lblSimplesTitulo" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_GRADE">
                        <span class="s-h4">Grade: </span><span class="s-h4 regular">{{dadosAba.historicoEscolar.dadosAluno.grade}}</span>
</p>

                    <p class="lblSimplesTitulo" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_ENADE">
                        <span class="s-h4">ENADE: </span><span class="s-h4 regular">{{dadosAba.historicoEscolar.dadosAluno.enade}}</span>
                    </p>

                </div>
                <div class="divHistoricoEscolar">

                    <p class="lblSimplesTitulo" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_INICIOTURMA">
                        <span class="s-h4">Início da turma: </span>
                        <span class="lblSimplesDescricao s-h4 regular" v-formatdate="dadosAba.historicoEscolar.turma.inicio"></span>
                    </p>

                    <p class="lblSimplesTitulo" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_FIMTURMA">
                        <span class="s-h4">Fim da Turma: </span>
                        <span class="lblSimplesDescricao s-h4 regular" v-formatdate="dadosAba.historicoEscolar.turma.termino"></span>
                    </p>

                </div>

                <div style="clear:both"><br /></div>

                <Grid v-bind:Data="dadosAba.historicoEscolar.disciplina"
                      v-bind:Header="header"
                      Name="HistoricoEscolar"
                      Title="Total"
                      OrderBy="periodoLetivo"
                      v-bind:DetalhesCombo1="dadosAba.periodo"
                      v-bind:DetalhesCombo2="dadosAba.situacao"
                      v-bind:DetalhesCombo3="null" v-if="$featureToggle && $featureToggle.INTEGRA_HISTORICOESCOLAR_GRID" />
            </div>
        </div>
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Info from '@/components/Info';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import HistoricoEscolar from '@/services/HistoricoEscolarService.js';
    import { formatdatetime } from '@/directives/formatdatetime.js';
    import { formatdate } from '@/directives/formatdate.js';

    export default {
        components: {
            Grid,
            Loading,
            Info,
            PageTitle
        },
        directives: {
            formatdate,
            formatdatetime
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.HistoricoEscolar) {
                        this.dadosAba = a.HistoricoEscolar;
                    }
                }
                else
                    this.$router.push('home');
            }

            this.historicoEscolarService = new HistoricoEscolar(this);

            if (this.$featureToggle.INTEGRA_HISTORICOESCOLAR_GRID) {
                //Verifica se a aba não está carregada
                if (!this.dadosAba) {
                    //Popula os dados da aba
                    this.showLoading = true;
                    this.historicoEscolarService.ObterHistoricoEscolar({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoTurma: this.aluno.codigoTurma,
                        CodigoEmpresa: this.aluno.codigoEmpresa
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.HistoricoEscolar = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                expandPrincipal: true,
                expandInfo: true,
                aluno: null,
                showLoading: false,
                header: [
                    {
                        Titulo: "Período",
                        Field: "periodoLetivo",
                        Width: "100px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Série",
                        Field: "semestre",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Disciplina",
                        Field: "nomeDisciplinaCompleto",
                        Width: "200px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Carga Horária",
                        Field: "cargaHoraria",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Frequência (%)",
                        Field: "percentualFrequencia",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Média",
                        Field: "notaFinal",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Situação",
                        Field: "situacaoFinal",
                        Width: "80px",
                        Tipo: "texto"
                    }
                ],
                dadosAba: null
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .info {
        float: left;
    }

    .s-h2 {
        padding-left: 15px;
        margin-bottom: 16px;
        margin-left: 0px;
    }

    .list {
        width: 320px;
    }

    .lblSimplesTitulo {
        font-size: 16px;
        padding: 10px 0 0px 15px;
        margin: 0px;
    }

    .divHistoricoEscolar {
        width: 30%;
        float: left;
        position: relative;
        display: inline;
    }

    .div330{
        width:31% !important;
    }
</style>
